import { Dispatch, SetStateAction } from "react";
import { Stack } from "@mui/material";
import { JsonTagSelector } from "../../../components/TagManagement/JsonTagSelector";
import { ControllerRenderProps } from "react-hook-form";

interface CompanyTagFieldProps {
    company: any;
    setCompany: Dispatch<SetStateAction<any>>;
    field: ControllerRenderProps<any, "tags">;
    isProvider?: boolean;
}

export const CompanyTagField = ({ company, setCompany, field, isProvider = false }: CompanyTagFieldProps) => {
    const handleTagsChange = (updatedTags: Record<string, string[]>) => {
        setCompany((prevState: any) => {
            return {
                ...prevState,
                tags: updatedTags,
            };
        });

        // Update form field for validation
        field.onChange(updatedTags);
    };

    return (
        <Stack gap={1}>
            <JsonTagSelector
                entity={{
                    id: company.id || "new",
                    tags: company.tags || {},
                }}
                entityClass="App\Entity\Company"
                context={isProvider ? "supplier" : "organization"}
                onTagsChange={handleTagsChange}
            />
        </Stack>
    );
};
